module.exports = __webpack_public_path__ + "img/ResultsTypes_Environmental_&_Recreational_Risks.bff515ca.jpg";